module.exports = __webpack_public_path__ + "img/co-pace-blueprint.afe2d640.png";